// import React from "react";
// import "../styles/Footer.css";

// export default function Footer() {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="footer-section">
//       <div className="footer-container">
//         {/* About */}
//         <div className="footer-about">
//           <h3>Malware Detection System</h3>
//           <p>
//             Secure your files with AI-powered malware scanning. Fast, reliable,
//             and easy to use.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div className="footer-links">
//           <h4>Quick Links</h4>
//           <ul>
//             <li><a href="#home">Home</a></li>
//             <li><a href="#upload">Upload & Scan</a></li>
//             <li><a href="#history">Scan History</a></li>
//           </ul>
//         </div>

//         {/* Contact */}
//         <div className="footer-contact">
//           <h4>Contact</h4>
//           <p>Email: support@malware-system.com</p>
//           <p>Phone: +1 234 567 8901</p>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <p>© {currentYear} Malware Detection System. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

import "../styles/Footer.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* About Section */}
        <div className="footer-about">
          <h3>Malware Detection System</h3>
          <p>
            Secure your files with AI-powered malware scanning. Fast, reliable,
            and easy to use.
          </p>

          {/* Social Icons */}
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#upload">Upload & Scan</a></li>
            <li><a href="#history">Scan History</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>Email: support@malware-system.com</p>
          <p>Phone: +1 234 567 8901</p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Malware Detection System. All rights reserved.</p>
      </div>
    </footer>
  );
}